import { render, staticRenderFns } from "./privacy_policy.vue?vue&type=template&id=be077cbe&scoped=true&"
import script from "./privacy_policy.vue?vue&type=script&lang=js&"
export * from "./privacy_policy.vue?vue&type=script&lang=js&"
import style0 from "./privacy_policy.vue?vue&type=style&index=0&id=be077cbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be077cbe",
  null
  
)

export default component.exports